/**
 * Represents session behavior configuration with different connection strategies
 */
export class SessionBehavior {
    public readonly initialSuffix: string;
    public readonly subsequentSuffix: string | null;

    constructor(initialSuffix: string, subsequentSuffix: string | null) {
        this.initialSuffix = initialSuffix;
        this.subsequentSuffix = subsequentSuffix;
    }

    static simple(): SessionBehavior {
        return new SessionBehavior('', null);
    }

    static incremental(): SessionBehavior {
        return new SessionBehavior('', '/incremental');
    }

    static cyclicalUnified(): SessionBehavior {
        return new SessionBehavior('/cyclical/unified', null);
    }

    static cyclicalUnifiedOnDemand(): SessionBehavior {
        return new SessionBehavior('/cyclical/unified_on_demand', null);
    }

    static cyclicalDelta(): SessionBehavior {
        return new SessionBehavior('/cyclical/bootstrap', '/cyclical/delta');
    }

    static delta(): SessionBehavior {
        return new SessionBehavior('/bootstrap', '/delta');
    }
}
